// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__u9b-s","actionsCol":"EnrolledClinics_actionsCol__234Vc"};